/*
 * About-Kopf: Film und Bildwechsel (Alex, Pastel #38, 23.09.).
 *
 * 1. "can we show the movie here fullscreen when we click on play?"
 *    Der Dialog fuellt schon per CSS das ganze Fenster. Zusaetzlich wird echtes Vollbild angefragt;
 *    lehnt der Browser ab (Safari auf dem iPhone erlaubt es nur fuer das <video> selbst), bleibt es beim
 *    fensterfuellenden Dialog. Kein Autoplay ohne Klick.
 *
 * 2. "if we don't start the video yet, the picture blends to a new one every 10 seconds."
 *    Laeuft nur, wenn im Theme-Editor weitere Bilder als Bloecke liegen. Pause, solange der Film offen ist,
 *    bei unsichtbarem Tab und bei prefers-reduced-motion. Das alte Bild bleibt waehrend der 500 ms deckend
 *    liegen, sonst kaeme der Hintergrund durch (gleiche Loesung wie im Hero der Startseite, Pastel #40).
 */
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initGallery = (root, isBlocked) => {
    const images = [...root.querySelectorAll('[data-about-image]')];
    if (images.length < 2) return () => {};
    const wait = Math.max(2, parseFloat(root.dataset.interval) || 10) * 1000;
    let current = 0;
    let timer = 0;
    let prev = null;
    let prevTimer = 0;

    const step = () => {
      timer = 0;
      if (isBlocked() || document.hidden || motion.matches) { schedule(); return; }
      const out = images[current];
      current = (current + 1) % images.length;
      if (prev && prev !== out) prev.classList.remove('is-prev');
      window.clearTimeout(prevTimer);
      out.classList.remove('is-active');
      out.classList.add('is-prev');
      prev = out;
      prevTimer = window.setTimeout(() => { out.classList.remove('is-prev'); prev = null; }, 500);
      images[current].classList.add('is-active');
      schedule();
    };
    const schedule = () => { if (!timer) timer = window.setTimeout(step, wait); };

    document.addEventListener('visibilitychange', schedule);
    schedule();
    return schedule;
  };

  document.querySelectorAll('.about-hero').forEach((section) => {
    const dialog = section.querySelector('.js-about-hero-dialog');
    const video = section.querySelector('.js-about-hero-video');
    const button = section.querySelector('.js-about-hero-play');
    const gallery = section.querySelector('[data-about-gallery]');
    let open = false;

    if (gallery) initGallery(gallery, () => open);
    if (!dialog || !button) return;

    button.addEventListener('click', () => {
      open = true;
      dialog.showModal();
      if (dialog.requestFullscreen) dialog.requestFullscreen().catch(() => {});
      else if (video && video.webkitEnterFullscreen) { try { video.webkitEnterFullscreen(); } catch (e) { /* bleibt im Dialog */ } }
      if (video) video.play().catch(() => {});
    });

    dialog.addEventListener('close', () => {
      open = false;
      if (video) video.pause();
      if (document.fullscreenElement) document.exitFullscreen().catch(() => {});
    });

    // Verlaesst der Nutzer das Vollbild (Escape), soll auch der Dialog zugehen.
    document.addEventListener('fullscreenchange', () => {
      if (!document.fullscreenElement && dialog.open) dialog.close();
    });
  });
})();
